import { render } from "./Book2.vue?vue&type=template&id=6d654e9b"
import script from "./Book2.vue?vue&type=script&lang=js"
export * from "./Book2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__